import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00720-input-form q-gutter-y-sm" }
const _hoisted_2 = { class: "row q-mt-none" }
const _hoisted_3 = { class: "col column" }
const _hoisted_4 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col column" }
const _hoisted_7 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_8 = { class: "row q-gutter-sm" }
const _hoisted_9 = { class: "col-2 column" }
const _hoisted_10 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_11 = { class: "col column" }
const _hoisted_12 = { class: "q-mb-none q-ml-sm q-mt-xs supplier-name" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col column" }
const _hoisted_15 = {
  class: "row q-gutter-x-md",
  style: {"margin-top":"6px"}
}
const _hoisted_16 = { class: "col-2 column" }
const _hoisted_17 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_18 = { class: "col-3 column" }
const _hoisted_19 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_20 = { class: "col-3 column" }
const _hoisted_21 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_22 = { class: "col column" }
const _hoisted_23 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col column" }
const _hoisted_26 = { class: "q-mb-none q-ml-sm q-mt-xs" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col q-gutter-x-xs flex justify-end" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import commaFormat from '../../common/utils/numberUtils';
import { isEmpty } from '../../common/utils/validateUtils';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';

interface Props {
  // カタログID
  catalogId: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00720',
  props: {
    catalogId: {}
  },
  setup(__props: any) {

const router = useRouter();
const props = __props;

// MessageChip表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');

// SDFile更新確認フラグ
const isSdfConfirmationFlg = ref(false);
// SDFile更新完了フラグ
const isSdfCompleteFlg = ref(false);
// SDFile存在なしフラグ
const isSdfNotExistFlg = ref(false);

// 初期化用データ
const resetData = reactive({
  catalog_id: '',
  sup_category: '',
  supplier_code: '',
  supplier_name: '',
  sup_sdfile_name: '',
  item_num: '',
  poison_num: '',
  ban_num: '',
  special_num: '',
  update_timestamp: '',
  memo: '',
});

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

// 入力データ
const inputData = ref({ ...resetData });

/**
 * フォーム初期化
 */
const resetForm = () => {
  errMessage.value = '';
  isMessageChip.value = false;
  inputData.value = { ...resetData };
};

/**
 * SDFile情報取得
 */
const getSdfInfo = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('catalog_id', props.catalogId);

  // SDFile情報取得
  await axios
    .post('/cmd007201/get-sdf-info', formData)
    .then((res) => {
      const { common, sdfInfo } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          Object.assign(resetData, sdfInfo);
          inputData.value = sdfInfo;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // SDFileが存在しない場合
            case DetailResultStatusCode.SDF_NOT_EXIST_ERROR:
              isSdfNotExistFlg.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDFile更新
 */
const updateSdfile = async () => {
  isSdfConfirmationFlg.value = false;
  errMessage.value = '';
  isMessageChip.value = false;
  // Loading Start
  Loading.show();
  // 更新データ
  const formData = new FormData();
  formData.append('catalog_id', props.catalogId);
  formData.append('sup_sdfile_name', inputData.value.sup_sdfile_name);
  formData.append('memo', inputData.value.memo ? inputData.value.memo : '');

  // SDFile更新
  await axios
    .post('/cmd007201/update-sdf', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isSdfCompleteFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // 更新に失敗した場合
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.catalogId) {
  // 前画面に遷移
  router.push({ name: 'sdfile' });
} else {
  // SDFile情報取得
  getSdfInfo();
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode("SDFile変更")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      onSubmit: _cache[4] || (_cache[4] = ($event: any) => (isSdfConfirmationFlg.value = true)),
      onReset: resetForm,
      onValidationError: resetError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, "カタログID", -1)),
              _createElementVNode("p", _hoisted_4, _toDisplayString(inputData.value.catalog_id), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "カテゴリー", -1)),
              _createElementVNode("p", _hoisted_7, _toDisplayString(inputData.value.sup_category), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[12] || (_cache[12] = _createElementVNode("label", null, "サプライヤコード", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(inputData.value.supplier_code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "サプライヤ名", -1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(inputData.value.supplier_name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "requier" }, "SDFile名", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.sup_sdfile_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.sup_sdfile_name) = $event)),
                outlined: "",
                clearable: "",
                dense: "",
                style: {"background":"var(--q-white)"},
                class: "input-area left-input",
                maxlength: "200",
                rules: [
                (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                (val) => !(val.length <= 5) || _ctx.$t('validation.chara_min_length', { param1: '6' }),
              ],
                "lazy-rules": "",
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "品目数", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(inputData.value.item_num ? _unref(commaFormat)(inputData.value.item_num) : '0'), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "毒劇品目数", -1)),
              _createElementVNode("p", _hoisted_19, _toDisplayString(inputData.value.poison_num !== null ? _unref(commaFormat)(inputData.value.poison_num) : '未実施'), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "輸入禁止品目数", -1)),
              _createElementVNode("p", _hoisted_21, _toDisplayString(inputData.value.ban_num !== null ? _unref(commaFormat)(inputData.value.ban_num) : '未実施'), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[18] || (_cache[18] = _createElementVNode("label", null, "法規制チェックエラー品目数", -1)),
              _createElementVNode("p", _hoisted_23, _toDisplayString(inputData.value.special_num !== null ? _unref(commaFormat)(inputData.value.special_num) : '未実施'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[19] || (_cache[19] = _createElementVNode("label", null, "更新日時", -1)),
              _createElementVNode("p", _hoisted_26, _toDisplayString(inputData.value.update_timestamp), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[20] || (_cache[20] = _createElementVNode("label", null, "備考", -1)),
              _createVNode(_component_q_input, {
                modelValue: inputData.value.memo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.memo) = $event)),
                outlined: "",
                dense: "",
                type: "textarea",
                counter: "",
                rows: "3",
                "bg-color": "white",
                maxlength: "200",
                class: "q-pb-none"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'sdfile' })))
                }),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: "変更"
                  }),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: "cached",
                    label: "リセット"
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isSdfConfirmationFlg.value,
      level: "information",
      title: "更新確認",
      text: ['入力された内容で更新します。', 'よろしいですか？'],
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (updateSdfile())),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (isSdfConfirmationFlg.value = false))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: isSdfCompleteFlg.value,
      level: "information",
      title: "更新完了",
      text: ['SDFileの更新が完了しました。'],
      confirmation: "",
      onComplete: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push({ name: 'sdfile' })))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: isSdfNotExistFlg.value,
      level: "warning",
      title: "データが存在しません",
      text: ['該当のデータが存在しませんでした。', '再度SDFile一覧から選択してください。'],
      confirmation: "",
      onComplete: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push({ name: 'sdfile' })))
    }, null, 8, ["display"])
  ]))
}
}

})